import { contactContent } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-2xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading">
            联系投稿
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mt-2">
            {contactContent.subtitle}
          </p>
        </div>

        <div className="bg-background-100 rounded-2xl border border-background-200/70 p-6 md:p-10">
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed text-center mb-8">
            {contactContent.description}
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="flex flex-col items-center gap-2 p-4 rounded-xl bg-background-50 border border-background-200/70">
              <div className="w-10 h-10 rounded-lg bg-primary-50 flex items-center justify-center">
                <i className="ri-mail-line text-primary-500 text-lg"></i>
              </div>
              <span className="text-xs text-foreground-400">电子邮箱</span>
              <span className="text-sm font-medium text-foreground-700">{contactContent.email}</span>
            </div>

            <div className="flex flex-col items-center gap-2 p-4 rounded-xl bg-background-50 border border-background-200/70">
              <div className="w-10 h-10 rounded-lg bg-accent-50 flex items-center justify-center">
                <i className="ri-qq-line text-accent-500 text-lg"></i>
              </div>
              <span className="text-xs text-foreground-400">QQ群</span>
              <span className="text-sm font-medium text-foreground-700">{contactContent.qq}</span>
            </div>

            <div className="flex flex-col items-center gap-2 p-4 rounded-xl bg-background-50 border border-background-200/70">
              <div className="w-10 h-10 rounded-lg bg-secondary-50 flex items-center justify-center">
                <i className="ri-wechat-line text-secondary-500 text-lg"></i>
              </div>
              <span className="text-xs text-foreground-400">微信公众号</span>
              <span className="text-sm font-medium text-foreground-700">{contactContent.wechat}</span>
            </div>
          </div>

          <div className="mt-8 text-center">
            <a
              href="#hero"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-lg border-2 border-primary-200 text-primary-600 font-semibold text-sm hover:bg-primary-50 transition-colors cursor-pointer whitespace-nowrap no-underline"
            >
              <i className="ri-send-plane-line"></i>
              提交剧集反馈
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}